
  import ImageLoader from "@/assets/scripts/ImageLoader";
  import HeaderLayout from "@/components/layouts/Header.vue";
  import FooterLayout from "@/components/layouts/Footer.vue";
  import SingleBlock from "@/components/blocks/Single.vue";
  import TripleBlock from "@/components/blocks/Triple.vue";
  import NoticeAlert from "@/components/alerts/Notice.vue";

  export default {
    name: "TarievenView",
    components: {
      HeaderLayout,
      FooterLayout,
      SingleBlock,
      TripleBlock,
      NoticeAlert,
    },
    data() {
      return {
        tarievenImage: ImageLoader.loadImageSrc("assets/images/decorators/tarieven.jpg"),
        googleMapsUrl: "https://www.google.com/maps/dir//Hoogaars+80,+3232+TG+Brielle/@51.8923428,4.1541804,17z/data=!4m18!1m8!3m7!1s0x47c45276d0ce0961:0xc87cada5d267c673!2sHoogaars+80,+3232+TG+Brielle!3b1!8m2!3d51.8923395!4d4.1567553!16s%2Fg%2F11cp9lk1b4!4m8!1m0!1m5!1m1!1s0x47c45276d0ce0961:0xc87cada5d267c673!2m2!1d4.1567553!2d51.8923395!3e0?entry=ttu&g_ep=EgoyMDI2MDkzMC4wIKXMDSoASAFQAw%3D%3D",
      };
    },
  };
